import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    <a
      href='https://github.com/abdulmukit-n/cleanfolio'
      className='link footer__link'
    >
      Created By Abdul Mukit Nagaria
    </a>
  </footer>
)

export default Footer
